import moment from "moment";
import Vue from "vue";
import Component from "vue-class-component";
import PreviewPopupComponent from "../preview-popup/preview-popup.component.vue";
import { applicantDetialsApi } from "@/providers/apis/applicant-dashboard";
import AppLoaderComponent from "../app-loader/app-loader.component.vue";
import { filters } from "@/models/common-interface/common.interface";
import { appConfigService } from "@/providers/services/app/app-config";
import { utils } from "@/utils/utils";
import ErrorPopupComponent from "../error-popup/error-popup.component.vue";
@Component({
  name: "user-document-library",
  components: {
    PreviewPopupComponent,
    AppLoaderComponent,
    ErrorPopupComponent,
  },
})
export default class UserDocumentLibraryComponent extends Vue {
  public storeFullLibrary: any[] = [];
  public tableFields = [
    {
      key: "originalFileName",
      label: "Document Name",
      sortable: true,
    },
    {
      key: "type",
      label: "Type",
      sortable: true,
      thClass: "application_id",
      tdClass: "type",
    },
    {
      key: "date",
      label: "Date",
      sortable: false,
      thClass: "application_id pointer-events",
    },
    {
      key: "application",
      label: "Application Name",
      sortable: false,
      thClass: "application_id pointer-events",
    },
    {
      key: "uploadedBy",
      label: "Uploaded By",
      sortable: true,
      thClass: "application_id",
    },
  ];
  public currentPage = 1;
  public previewFile: any[] = [];
  public imgType = ["jpg", "png", "jpeg", "tiff"];
  public showPreviewPopup = false;
  public S3Path = "";
  public limit = 8;
  public offset = 0;
  public totalItem = 0;
  public page = 1;
  public filterDetails: filters = {} as filters;
  public isLoading = true;
  public libraryData: any = {
    partOne: [],
    partTwo: [],
    renewal: [],
    statetostate: [],
  };
  public applicationNameObj: any = {
    "Part One Application": "partOne",
    "Initial Application": "partTwo",
    "Renewal Application": "renewal",
    "Inactive Application": "inactive",
  };
  public formName: any = {
    partOne: "Training Application",
    partTwo: "Initial Application",
    renewal: "Renewal Application",
    inactive: "Inactive Application",
  };
  public isDataEmpty = false;
  public errorMessage = "";

  public created() {
    this.S3Path = appConfigService.getS3FilesPathUrl();
    this.getLibraryData();
  }
  public getLibraryData() {
    this.filterDetails.limit = this.limit;
    this.filterDetails.offset = this.offset;
    this.isLoading = true;
    applicantDetialsApi
      .getDocumentsLibrary(this.filterDetails)
      .then((libraryData: any) => {
        this.isLoading = false;
        this.totalItem = libraryData.totalCount;
        if (libraryData.documents.length) {
          this.isDataEmpty = false;
          libraryData.documents.map((document: any) => {
            const applicantKey = this.applicationNameObj[document.application];
            if (!this.libraryData[applicantKey].length) {
              this.libraryData[applicantKey] = [document];
            } else {
              this.libraryData[applicantKey].push(document);
            }
          });
          for (const property in this.libraryData) {
            this.libraryData[property].map((data: any) => {
              data.type = data.uploadedFileName.split(".")[1];
              data.date = moment(data.uploadedAt).format("MM-DD-YYYY");
              data.application = this.formName[property];
              data.uploadedBy = `${data.firstName || ""} ${
                data.lastName || ""
              }`.trim();
              if (this.storeFullLibrary.length) {
                this.storeFullLibrary.push(data);
              } else {
                this.storeFullLibrary = [data];
              }
            });
          }
          this.storeFullLibrary = this.storeFullLibrary.sort(
            (a: any, b: any) => {
              a.date = moment(a.date).format("MM-DD-YYYY HH:mm:ss:SSS");
              b.date = moment(b.date).format("MM-DD-YYYY HH:mm:ss:SSS");
              return new Date(a.date).getTime() - new Date(b.date).getTime();
            }
          );
          this.storeFullLibrary.map((data: any) => {
            data.date = moment.utc(data.date).local().format("MM-DD-YYYY");
          });
          this.storeFullLibrary.reverse();
        } else {
          this.isDataEmpty = true;
        }
      })
      .catch((error) => {
        this.isDataEmpty = true;
        this.errorMessage = utils.errorMessage(error);
        this.isLoading = false;
      });
  }

  public closePopup() {
    this.$bvModal.hide("error-modal-center");
  }

  public loadContent(page: number) {
    this.page = page;
    this.offset = (this.page - 1) * this.limit;
    this.getLibraryData();
  }

  public previewForm(rowData: any) {
    const previewData = rowData;
    if (this.imgType.includes(previewData.uploadedFileName.split(".")[1])) {
      const img = new Image();
      img.src = `${this.S3Path}/${previewData.uploadedFileName}`;
      previewData.width = img.width;
      previewData.height = img.height;
    }
    this.previewFile = [previewData];
    this.showPreviewPopup = true;
  }
  public hidePreviewPopup(event: boolean) {
    if (event === true) {
      this.showPreviewPopup = false;
      this.previewFile = [];
    }
  }

  public closdedErrorPopup(event: any) {
    if (event) {
      this.errorMessage = "";
    }
  }
}
